<template>
    <div class="latest-result" @mouseleave="hoverItem = null">
        <div class="hd">
            <span class="hd-title"><i class="el-icon-refresh" @click="refresh"></i> 缩水网最新开奖</span>
            <span class="more" @click="refresh">更多 <i class="el-icon-arrow-right"></i></span>
        </div>
        <div class="item" v-for="(item, index) in list" :key="index" @click="goDetail(item)"
            @mouseenter="hoverItem = item">
            <div class="head">
                <b>{{ item.name }}</b>
                <span class="issue">{{ item.issue }}</span>
                <span class="date">{{ item.date }}</span>
            </div>
            <div class="balls">
                <span class="ball" v-for="(n, i) in item.red" :key="'r' + i">{{ n }}</span>
                <span class="ball blue" v-for="(n, i) in item.blue" :key="'b' + i">{{ n }}</span>
                <template v-if="item.test">
                    <span class="test-label">{{ item.testLabel }}</span>
                    <span class="test-box">
                        <i v-for="(n, i) in item.test" :key="'t' + i">{{ n }}</i>
                    </span>
                </template>
            </div>
            <i class="el-icon-arrow-right arrow"></i>
        </div>
        <!-- 悬浮详情面板：置于 left 内，绝对定位到 left 右侧，hoverItem 驱动显隐 -->
        <div class="panel" v-if="hoverItem && currentPanel">
            <div class="p-hd">
                <b>{{ currentPanel.title }}</b>
                <span class="p-time"><i class="el-icon-time"></i> 开奖时间待接入</span>
            </div>
            <div class="p-sec" v-for="(sec, si) in currentPanel.sections" :key="si">
                <div class="p-sec-hd" v-if="sec.title"><i :class="sec.icon"></i> {{ sec.title }}</div>
                <div class="p-sec-body">
                    <a class="p-link" v-if="it.link" :href="it.link" target="_blank" rel="noopener noreferrer"
                        v-for="(it, ii) in sec.items" :key="ii">{{ it.name }}</a>
                    <span class="p-link" v-else v-for="(it, iii) in sec.items" :key="iii" @click="goPanelLink(it)">{{
                        it.name
                    }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 最新开奖板块：当前为假数据占位，正式接口就绪后只需替换 list 数据来源（refresh 方法内请求即可）
// 后端已有真实接口参考：GET /stage-api/lottery/result/latest/all（type: 0双色球 1大乐透 2福彩3D 3排列三）
export default {
    data() {
        return {
            // 假数据：字段说明 name 彩种名 / issue 期号 / date 开奖日期+星期 / red 红球(普通球) / blue 蓝球(特别号) / test 模拟试机号数字 / testLabel 试机号标签
            list: [
                { name: '福彩3D', issue: '第 251期', date: '09-18 星期五', red: ['7', '7', '7'], blue: [], test: ['3', '2', '9'], testLabel: '251期模拟试机号' },
                { name: '双色球', issue: '第 108期', date: '09-17 星期四', red: ['06', '11', '13', '14', '20', '28'], blue: ['16'], test: null, testLabel: '' },
                { name: '大乐透', issue: '第 101期', date: '09-17 星期四', red: ['02', '08', '11', '19', '27'], blue: ['05', '11'], test: null, testLabel: '' },
                { name: '排列3', issue: '第 251期', date: '09-18 星期五', red: ['2', '3', '7'], blue: [], test: ['1', '9', '8'], testLabel: '251期模拟试机号' },
            ],
            // 悬浮详情面板内容：按彩种区分（假数据，正式接口/跳转地址就绪后替换）
            // sections: title 分区标题(可空则不渲染标题栏) / items 链接文字 / cols 列数(默认1列)
            panelData: {
                '双色球': {
                    title: '双色球走势图工具',
                    sections: [
                        { title: '走势图表', icon: 'el-icon-data-line', items: [{ name: '历史开奖号码', link: 'https://caipiao.ip138.com/shuangseqiu/' }, { name: '号码走势图', link: 'https://caipiao.ip138.com/shuangseqiu/haoma/' }, { name: '路珠分析', link: 'https://caipiao.ip138.com/shuangseqiu/luzhu/' }, { name: '定位走势图', link: 'https://caipiao.ip138.com/shuangseqiu/dingwei/' }, { name: '红球三分区走势图', link: 'https://caipiao.ip138.com/shuangseqiu/sanqu/' }, { name: '红球大小走势图', link: 'https://caipiao.ip138.com/shuangseqiu/daxiao/' }, { name: '红球单双走势图', link: 'https://caipiao.ip138.com/shuangseqiu/danshuang/' }, { name: '红球质合走势图', link: 'https://caipiao.ip138.com/shuangseqiu/zhihe/' }, { name: '红球和值走势图', link: 'https://caipiao.ip138.com/shuangseqiu/hezhi/' }, { name: '红球首尾走势图', link: 'https://caipiao.ip138.com/shuangseqiu/kuadu/' }] },
                        { title: '五行走势图', icon: 'el-icon-data-line', items: [{ name: '五行走势图', link: 'https://caipiao.ip138.com/shuangseqiu/wuxing/' }] },
                        { title: '选号工具', icon: 'el-icon-edit', items: [{ name: '在线缩水', link: 'https://www.3533.com/shuangseqiu/' }, { name: '在线机选', link: 'https://www.3533.com/shuangseqiu/jixuan/' }, { name: 'AC值计算器', link: 'https://www.3533.com/shuangseqiu/ac/' }, { name: '胆拖计算器', link: 'https://www.3533.com/shuangseqiu/dantuo/' }, { name: '复式计算器', link: 'https://www.3533.com/shuangseqiu/fushi/' }] },
                    ],
                },
                '大乐透': {
                    title: '大乐透走势图工具',
                    sections: [
                        { title: '走势图表', icon: 'el-icon-data-line', items: [{ name: '历史开奖号码', link: 'https://caipiao.ip138.com/daletou/' }, { name: '号码走势图', link: 'https://caipiao.ip138.com/daletou/haoma/#1,1,0' }, { name: '路珠分析', link: 'https://caipiao.ip138.com/daletou/luzhu/' }, { name: '定位走势图', link: 'https://caipiao.ip138.com/daletou/dingwei/#1,0,0,0,0,0,0,1,1,0' }, { name: '前区三分区走势图', link: 'https://caipiao.ip138.com/daletou/sanqu/#1,0' }, { name: '前区大小走势图', link: 'https://caipiao.ip138.com/daletou/daxiao/' }, { name: '前区单双走势图', link: 'https://caipiao.ip138.com/daletou/danshuang/' }, { name: '前区质合走势图', link: 'https://caipiao.ip138.com/daletou/zhihe/' }, { name: '前区和值走势图', link: 'https://caipiao.ip138.com/daletou/hezhi/' }, { name: '前区首尾走势图', link: 'https://caipiao.ip138.com/daletou/kuadu/' }, { name: '五行走势图', link: 'https://caipiao.ip138.com/daletou/wuxing/' }] },
                        { title: '选号工具', icon: 'el-icon-edit', items: [{ name: '在线缩水', link: 'https://www.3533.com/daletou/' }, { name: '在线机选', link: 'https://www.3533.com/daletou/jixuan/' }, { name: 'AC值计算器', link: 'https://www.3533.com/daletou/ac/' }, { name: '胆拖计算器', link: 'https://www.3533.com/daletou/dantuo/' }, { name: '复式计算器', link: 'https://www.3533.com/daletou/fushi/' }] },
                    ],
                },
                '福彩3D': {
                    title: '福彩3D兵器库',
                    sections: [
                        { title: '', icon: '', items: [{ name: '在线缩水', link: 'https://www.3533.com/pailie3/' }, { name: '复式全排列组号器', link: 'https://www.3533.com/3d/fushi/' }, { name: '和值全排列组号器', link: 'https://www.3533.com/3d/hezhi/' }, { name: '冷热分析', link: 'https://caipiao.ip138.com/3d/lengre/#0' }, { name: '大小全排列组号器', link: 'https://www.3533.com/3d/daxiao/' }, { name: '开奖公告', link: 'http://www.cwl.gov.cn/c/2023/10/15/556274.shtml' }, { name: '奇偶全排列组号器', link: 'https://www.3533.com/3d/jiou/' }, { name: '号码走势图', link: 'https://caipiao.ip138.com/3d/haoma/#1,1,0' }, { name: '往期开奖视频', link: 'http://www.cwl.gov.cn/ygkj/wqkjgg/fc3d/' }, { name: '历史开奖号码', link: 'http://www.cwl.gov.cn/ygkj/wqkjgg/fc3d/' }, { name: '路珠分析', link: 'https://caipiao.ip138.com/3d/luzhu/' }, { name: '定位走势图', link: 'https://caipiao.ip138.com/3d/dingwei/#1,0,0,1,1,0' }, { name: '大小走势图', link: 'https://caipiao.ip138.com/3d/daxiao/#1,1' }, { name: '单双走势图', link: 'https://caipiao.ip138.com/3d/danshuang/#1,1' }, { name: '质和走势图', link: 'https://caipiao.ip138.com/3d/zhihe/#1,1' }, { name: '和值走势图', link: 'https://caipiao.ip138.com/3d/hezhi/#1,1' }, { name: '首尾跨度', link: 'https://caipiao.ip138.com/3d/kuadu/#1,1' }, { name: '往期开奖视频', link: 'http://www.cwl.gov.cn/ygkj/wqkjgg/fc3d/' }] },
                    ],
                },
                '排列3': {
                    title: '排列三兵器库',
                    sections: [
                        { title: '', icon: '', items: [{ name: '在线缩水', link: 'https://www.3533.com/pailie3/' }, { name: '复式全排列组号器', link: 'https://www.3533.com/pailie3/fushi/' }, { name: '和值全排列组号器', link: 'https://www.3533.com/pailie3/hezhi/' }, { name: '冷热分析', link: 'https://caipiao.ip138.com/pailie3/lengre/#0' }, { name: '大小全排列组号器', link: 'https://www.3533.com/pailie3/daxiao/' }, { name: '开奖公告', link: 'https://caipiao.ip138.com/pailie3/' }, { name: '奇偶全排列组号器', link: 'https://www.3533.com/pailie3/jiou/' }, { name: '号码走势图', link: 'https://caipiao.ip138.com/pailie3/haoma/#1,1,0' }, { name: '往期开奖视频', link: 'https://www.lottery.gov.cn/xytc/index.html' }, { name: '历史开奖号码', link: 'https://www.lottery.gov.cn/kj/kjlb.html?pls' }, { name: '路珠分析', link: 'https://caipiao.ip138.com/pailie3/luzhu/' }, { name: '定位走势图', link: 'https://caipiao.ip138.com/pailie3/dingwei/#1,0,0,1,1,0' }, { name: '大小走势图', link: 'https://caipiao.ip138.com/pailie3/daxiao/#1,1' }, { name: '单双走势图', link: 'https://caipiao.ip138.com/pailie3/danshuang/#1,1' }, { name: '质和走势图', link: 'https://caipiao.ip138.com/pailie3/zhihe/#1,1' }, { name: '和值走势图', link: 'https://caipiao.ip138.com/pailie3/zhihe/#1,1' }, { name: '首尾跨度', link: 'https://caipiao.ip138.com/pailie3/kuadu/#1,1' }, { name: '往期开奖视频', link: 'https://www.lottery.gov.cn/xytc/index.html' }] },
                    ],
                },
            },
            // 当前悬浮的彩种（驱动右侧面板显隐与内容）
            hoverItem: null,
        };
    },
    computed: {
        // 当前悬浮彩种对应的面板内容（按彩种名匹配 panelData）
        currentPanel() {
            return this.hoverItem ? this.panelData[this.hoverItem.name] : null;
        }
    },
    methods: {
        // 刷新：假数据阶段空操作，正式接口就绪后在请求并重赋 this.list
        refresh() {
            // TODO 待接入正式接口
        },
        // 开奖详情跳转：预留，接口就绪后按需求补跳转地址
        goDetail(item) {
            // TODO 待接入正式接口
            console.log('开奖详情', item.name, item.issue);
        },
        // 面板内工具链接跳转：link 为空则仅打印（待你提供地址后填入 panelData）
        goPanelLink(it) {
            if (!it.link) {
                console.log('面板链接（未配置地址）', it.name);
                return;
            }
            if (/^https?:\/\//i.test(it.link)) {
                window.open(it.link, '_blank');
            } else {
                this.$router.push(it.link);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.latest-result {
    border: 1px solid rgba(0, 0, 0, 0.2);
    background: #fff;

    .hd {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        .hd-title {
            font-size: 16px;
            font-weight: bold;
            color: #333;

            i {
                cursor: pointer;
                color: #d43c33;
            }
        }

        .more {
            font-size: 13px;
            color: #d43c33;
            cursor: pointer;
        }
    }

    .item {
        position: relative;
        padding: 10px 20px 10px 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        cursor: pointer;
        transition: box-shadow 0.2s;

        &:hover {
            box-shadow: inset 0 0 0 1px #d43c33;
        }

        .head {
            display: flex;
            align-items: baseline;

            b {
                font-size: 15px;
                color: #333;
            }

            .issue {
                margin-left: 8px;
                font-size: 13px;
                color: #999;
            }

            .date {
                margin-left: auto;
                font-size: 12px;
                color: #999;
            }
        }

        .balls {
            margin-top: 8px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 4px;

            .ball {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background: #d43c33;
                color: #fff;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;

                &.blue {
                    background: #3d7edb;
                }
            }

            .test-label {
                margin-left: auto;
                font-size: 12px;
                color: #999;
                white-space: nowrap;
            }

            .test-box {
                display: flex;
                gap: 6px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                padding: 2px 8px;

                i {
                    font-style: normal;
                    font-size: 13px;
                    font-weight: bold;
                    color: #d43c33;

                    &:last-child {
                        color: #3d7edb;
                    }
                }
            }
        }

        .arrow {
            position: absolute;
            right: 6px;
            top: 50%;
            transform: translateY(-50%);
            color: #ccc;
        }
    }

    /* 悬浮详情面板：作为 left 内独立元素，相对 left 绝对定位到其右侧（top:0 left:100% bottom:0 撑满高度） */
    .panel {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 100%;
        width: 520px;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 200;
    }

    .p-hd {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 14px;
        background: #fdeeee;

        b {
            font-size: 16px;
            color: #d43c33;
        }

        .p-time {
            font-size: 13px;
            color: #999;

            i {
                margin-right: 4px;
            }
        }
    }

    .p-sec {
        .p-sec-hd {
            padding: 8px 14px;
            font-size: 14px;
            font-weight: bold;
            color: #d43c33;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);

            i {
                margin-right: 6px;
            }
        }

        .p-sec-body {
            padding: 8px 14px 12px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
            /* 链接按 4 列网格正常排列 */
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 8px;

            .p-link {
                display: block;
                padding: 4px 4px;
                font-size: 13px;
                color: #333;
                text-align: center;
                cursor: pointer;
                text-decoration: none;
                transition: color 0.2s;

                &:hover {
                    color: #d43c33;
                }
            }
        }

        .p-sec:last-child .p-sec-body {
            border-bottom: none;
        }
    }
}
</style>
